import TiposAtributoCliente from './list';
import TipoAtributoClienteForm from './form';

export default angular.module('spa.tipos-atributo-cliente', [
  TiposAtributoCliente, TipoAtributoClienteForm, 'ngTagsInput'
])
  .config(configNgTagsInput)
  .config(config).name;


config.$inject = ['$stateProvider', '$translatePartialLoaderProvider'];

function config($stateProvider, $translatePartialLoaderProvider) {
  $stateProvider
    .state('home.tipos-atributo-cliente', {
      url: 'tipos-atributo-cliente',
      abstract: true,
      template: '<ui-view></ui-view>',
      ncyBreadcrumb: {
        skip: true
      }
    });
  
  $translatePartialLoaderProvider.addPart('tipos-atributo-cliente');
}

/**
 * Configurar defaults de  ngTagsInput para este modulo.
 * @param {*} tagsInputConfigProvider 
 */
function configNgTagsInput(tagsInputConfigProvider) {
  tagsInputConfigProvider
    .setDefaults('tagsInput', {
      placeholder: 'Agregar campo y presionar enter',
      minLength: 1,
    });
}


// WEBPACK FOOTER //
// ./src/components/tipos-atributo-cliente/index.js